export const STORAGE_KEYS = {
  languageCodeKey: 'language_code',
  languageKey: 'language',
  USER: 'user',
  TOKEN: 'token',
  REFRESHTOKEN: 'refreshToken',
  REMEMBER_ME: 'rememberMe',
};
